import React from "react";

import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StarsIcon from '@mui/icons-material/Stars';
import LocationOnIcon from '@mui/icons-material/LocationOn';


function CajaTemporario(props) {

    return (
        <div className="contenedor-descripcion">
            <div className="linea-estetica"></div>
            <div className="descripcion-gancho" style={{color: "white"}}>
                <div className={"gancho-titulo"}>{props.titulo}</div>
                <div className={"boton-enfasis-2"}>{props.subtitulo}</div>
                <div className={"gancho-capacidad"}>
                    Capacidad
                    {Array.from({length: props.capacidad}, (_, i) => (
                        <PersonIcon
                            key={i}
                            style={{marginLeft: "2px"}}/>

                    ))
                    }
                </div>
                <div className={"gancho-opiniones"}>
                    Opiniones
                    {Array.from({length: props.testimonios}, (_, i) => (
                        <StarsIcon
                            key={i}
                            style={{marginLeft: "2px"}}/>

                    ))
                    }

                </div>
                <div className={"gancho-ubicacion"}>
                    <LocationOnIcon/>
                    <span>{props.ubicacion}</span>
                </div>
                <div className={"boton-enfasis"}>
                    <span>desde </span>
                    <strong>$ {props.precio} </strong>
                    <span> /por noche</span>
                </div>

            </div>
            <div className="descripcion-fotos">

                <div className="contenedor-slider">
                    <div className={"slide active-anim"}>
                    <img
                        src={process.env.PUBLIC_URL + require(`../imagenes/${props.carpeta}/Foto1.jpg`)}
                        alt={"img"}/>
                    </div>


                </div>


            </div>


        </div>
    );
}

export default CajaTemporario;


